import React, { useEffect } from "react";

interface IubendaProps {
  siteId: number;
  cookiePolicyId: number;
  showBanner: boolean;
}

const IubendaButton: React.FC<IubendaProps> = ({ siteId, cookiePolicyId, showBanner }) => {

  if (showBanner) {
    useEffect(() => {
      // Controlla se lo script è già stato caricato
        if (!document.getElementById("iubenda-script")) {
          // Crea l'elemento script per le opzioni di inizializzazione
          const iubendaOptionsScript = document.createElement("script");
          iubendaOptionsScript.innerHTML = `
            var _iub = _iub || [];
            _iub.csConfiguration = {
              "askConsentAtCookiePolicyUpdate":true,
              "floatingPreferencesButtonDisplay":"bottom-left",
              "perPurposeConsent":true,
              "reloadOnConsent":false,
              "siteId": ${siteId},
              "cookiePolicyId": ${cookiePolicyId},
              "lang": 'it',
              "banner": { 
                "acceptButtonDisplay":true,
                "closeButtonRejects":true,
                "customizeButtonDisplay":true,
                "explicitWithdrawal":true,
                "listPurposes":true,
                "prependOnBody":true
              }
            };
          `;
          document.head.appendChild(iubendaOptionsScript);

          const iubendaApiConfiguration = document.createElement("script");
          iubendaApiConfiguration.type = "text/javascript"
          iubendaApiConfiguration.textContent = `
            var _iub = _iub || {}; _iub.cons_instructions = _iub.cons_instructions || []; _iub.cons_instructions.push(["init", { api_key: "6EP1A6RZ8yvf0dpKtdw4dRAL5hzsLSsx" }]);
          `;

          const consentDatabase = document.createElement("script");
          consentDatabase.id = "iubenda-consent";
          consentDatabase.src = "https://cdn.iubenda.com/cons/iubenda_cons.js";

          const script = document.createElement("script");
          script.id = "iubenda-script";
          script.src = "//cdn.iubenda.com/cs/iubenda_cs.js";

          const banner = document.createElement("script");
          banner.id = "iubenda-banner";
          banner.src = `https://cs.iubenda.com/autoblocking/${siteId}.js`;

          script.async = true;
          banner.async = true;
          document.body.appendChild(banner);
          document.body.appendChild(script);
          document.head.appendChild(consentDatabase);
          document.head.appendChild(iubendaApiConfiguration);
        }
    }, [siteId, cookiePolicyId, showBanner]);
  }

  return null
};

export default IubendaButton;